import React from "react";
import { AlertTriangle } from "lucide-react";
import { EmptyState } from "@/components/ui/EmptyState";
import { Button } from "@/components/ui/button";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="grid min-h-[50vh] place-items-center p-6">
          <EmptyState
            tone="error"
            icon={<AlertTriangle size={20} strokeWidth={1.75} />}
            title="Something went wrong"
            description="Reload this page. If it keeps happening, check the API is running on port 8013."
            action={
              <Button variant="outline" onClick={() => window.location.reload()}>
                Reload
              </Button>
            }
          />
        </div>
      );
    }

    return this.props.children;
  }
}
